import styles from './Datepicker.module.css';
import 'react-datepicker/dist/react-datepicker.css';
import ReactDatePicker from 'react-datepicker';
import { classList } from '../../helpers';
import { FormLabel } from '../FormLabel';
import { FieldError } from '../FieldError';

const earliestDayTime = (date: Date) => new Date(date.setHours(0, 0, 0, 0));

export interface DatepickerProps {
  id?: string;
  name?: string;
  state?: 'normal' | 'valid' | 'error';
  label?: string;
  required?: boolean;
  readOnly?: boolean;
  error?: string;
  className?: string;
  value?: Date | null | undefined;
  onChange?: (date: Date | null, event: React.SyntheticEvent<any> | undefined) => void;
}
export const Datepicker = (props: DatepickerProps) => {
  const state = props.state && props.state != 'normal' ? props.state : undefined;
  let value = props.value;
  if (value && typeof value === 'string') {
    try {
      value = new Date(value);
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div className={props.className}>
      <FormLabel htmlFor={props.id} required={props.required}>
        {props.label}
      </FormLabel>
      <div className={classList(styles['input-container'], state ? styles[`input-container-${state}`] : undefined)}>
        <ReactDatePicker
          className={classList(styles.input, state ? styles[`input-${state}`] : undefined)}
          dateFormat='dd-MM-yyyy'
          dropdownMode='select'
          showMonthDropdown
          showYearDropdown
          selected={value}
          onChange={(date: Date | null, e?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
            if (props.onChange) {
              props.onChange(date ? earliestDayTime(date) : date, e);
            }
          }}
        />
      </div>
      {props.error && <FieldError>{props.error}</FieldError>}
    </div>
  );
};
